<template>
  <portal to="modalresult">
    <div class="modal-content modal-dialog-centered">
      <div class="overlay" id="overlay" :style=" { backgroundImage: `url(${backgroundImage})`}">
        <div style="padding-left:115px;" v-if="$route.name == 'detail'">
          <a @click="$router.push('/')">Beranda</a> / Hasil Pencarian
        </div>
        <div :class="$route.name == 'detail' ? 'modal-custom1' : 'modal-custom'">
          <component :is="component" v-bind="$attrs" />
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: "ModalResult",
  props: ["component"],
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/images/v284_292.png";
    }
  },
  data() {
    return {
      nilai: 'none',
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.nilai == 'none' && document.getElementById('daftar_menu_id').style.display == 'block' || this.lebar === 640 || this.lebar < 640) document.getElementById('overlay').style.top = "173.76px";
      document.getElementById('tombolMenu').addEventListener("click", function () {
        this.nilai = document.getElementById('daftar_menu_id').style.display;
        if (this.nilai == 'none') document.getElementById('overlay').style.top = "135px";
        if (this.nilai == 'block') document.getElementById('overlay').style.top = "173.76px";
      }
      );
    });
  },
  methods: {
  }
};
</script>

<style scoped>







.modal-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.modal-custom {
  margin-left: 5%;
    margin-right: 5%;
    margin-top: 5%;
  /* position: absolute; */
  /* z-index: 1; */
  /* margin: auto; */
  /* left: 50%; */
  /* top: 38%; */
  width: 90%;
  /* margin-left:70px;
  margin-right:70px; */
  height: auto;
  /* transform: translate(-50%, -50%); */
  padding-top:29px;
  padding-left:5%;
  padding-right:5%;
  box-shadow: 0 0 1em #00000033;
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 20px;
}

.modal-custom1 {
    margin-left: 5%;
      margin-right: 5%;
      margin-top: 5%;
  /* position: absolute; */
  /* z-index: 1; */
  /* margin: auto; */
  /* left: 49%; */
  /* top: 52%; */
  width: 90%;
  /* margin-left:70px;
  margin-right:70px; */
  height: auto;
  margin-bottom:30px;
  /* transform: translate(-50%, -50%); */
  padding-top:29px;
  padding-left:5%;
  padding-right:5%;
  box-shadow: 0 0 1em #00000033;
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 20px;
}
.overlay {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 135px;
  width: 100vw;
  height: 953px;
  background: rgba(5, 58, 105, 0.38) !important;
  /* backdrop-filter: blur(8px); */
}
/* .overlay {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 135px;
  width: 100vw;
  height: 953px;
  background: rgba(5, 58, 105, 0.38);
  background: white;
  background-repeat: no-repeat;
  background-size: contain;
} */
@media screen and (min-device-width: 240px) and (min-width: 240px) and (max-device-width: 640px) and (max-width: 640px) and (-webkit-min-device-pixel-ratio: 2) {
  .overlay {
    width: 100%;
    z-index: 1;
    height: 1287px;
  }

  .modal-custom {
    width: 90%;
    height: auto;
    /* top: 41.96% !important; */
    margin-left: 5% !important;
    margin-right: 5% !important;
  }
    .modal-custom1 {
      width: 90%;
      height: auto;
      /* top: 41.96% !important; */
      margin-left: 5% !important;
      margin-right: 5% !important;
    }

}
</style>
